// features/business-type/validation.js

export const validation = {
  name: (value) => {
    if (!value?.trim()) return "Business type is required";
    return "";
  },
};
